import { useState } from 'react'
import AttestatiService from '../services/AttestatiService/AttestatiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useAttestati = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingGeneraAttestato: false,
    isLoadingDownloadAttestato: false,
  });

  const [modalState, setModalState] = useState({
    showModalGeneraAttestato: false,
  });

  const generaAttestato = async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingGeneraAttestato: true }));
    try {
      const response = await AttestatiService.generaAttestato(data);
      alertService.success("Attestato generato con successo", {autoClose: true});
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingGeneraAttestato: false }));
    }
  }

  const downloadAttestato = async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingDownloadAttestato: true }));
    try {
      await AttestatiService.downloadAttestato(data);
      alertService.success("Download attestato completato", {autoClose: true});
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingDownloadAttestato: false }));
    }
  }

  const verifyAttestato = async (data) => {
    const response = await AttestatiService.verifyAttestato(data);
    return response;
  }

  return {
    loadingStateAttestati: loadingState,
    generaAttestato,
    downloadAttestato,
    modalStateAttestati: modalState,
    setModalStateAttestati: setModalState,
    verifyAttestato
  };      
}

export default useAttestati;  